var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#017EA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4202 16.9688H25.9202C24.7032 16.9688 23.7085 17.9517 23.7085 19.1688V20.2688C23.7085 21.4858 24.6915 22.4687 25.9085 22.4687H31.4202C32.6372 22.4687 33.6202 21.4858 33.6202 20.2688V19.1688C33.6319 17.9517 32.6372 16.9688 31.4202 16.9688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.802 20.2692C34.802 22.1299 33.2807 23.6512 31.4201 23.6512H25.9201C24.0595 23.6512 22.5382 22.1299 22.5382 20.2692C22.5382 19.6139 21.836 19.2043 21.2509 19.5086C19.6009 20.3863 18.4775 22.1299 18.4775 24.1309V35.1426C18.4775 38.0214 20.8297 40.3735 23.7084 40.3735H33.6318C36.5105 40.3735 38.8626 38.0214 38.8626 35.1426V24.1309C38.8626 22.1299 37.7392 20.3863 36.0892 19.5086C35.5041 19.2043 34.802 19.6139 34.802 20.2692ZM32.5786 29.5256L27.8978 34.2065C27.7222 34.382 27.4999 34.4639 27.2775 34.4639C27.0552 34.4639 26.8329 34.382 26.6573 34.2065L24.902 32.4511C24.5626 32.1118 24.5626 31.5501 24.902 31.2107C25.2414 30.8714 25.8031 30.8714 26.1424 31.2107L27.2775 32.3458L31.3382 28.2852C31.6775 27.9458 32.2392 27.9458 32.5786 28.2852C32.918 28.6246 32.918 29.1863 32.5786 29.5256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submitIcon.cfbec0f7931402cb6ea762db215657d6.svg";
export { ForwardRef as ReactComponent };